<template>
	<div class="money-tracker">
		<div class="label">{{ ui.balance_tracker }}</div>
		<AnimatedNumber :number="amount" :filters="'currency'" :class="{ animating }"
			@animation-start="animating = true" @animation-end="animating = false" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import AnimatedNumber from '@/components/base/AnimatedNumber';

export default {
	name: 'BalanceTracker',
	components: {
		AnimatedNumber,
	},
	computed: {
		...mapState({
			amount: (state) => state.game.balance.amount,
			ui: (state) => state.global.api.data.ui.header,
		}),
	},
	data: () => ({
		animating: false,
	}),
};
</script>

<style lang="scss" scoped>
	.money-tracker { text-align: right; }

	.label {
		color: $primary-color-light;
		font-size: $font-size-sm;
		text-transform: uppercase;
	}

	.animated-number {
		font-family: $heading-font;
		display: block;
		font-size: $font-size-lg;
		transform: scale(1);
		transform-origin: right center;
		transition: all $ui-transition-duration;

		@include desktop { font-size: $font-size-xl; }

		&.animating {
			color: $alt-color-extra-light;
			transform: scale(1.1);
		}
	}
</style>
